import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`npm is the world's largest software registry. Open source developers from every continent use npm to share and borrow packages, and many organizations use npm to manage private development as well.`}</p>
    <p>{`npm consists of three distinct components:`}</p>
    <ul>
      <li parentName="ul">{`the website`}</li>
      <li parentName="ul">{`the Command Line Interface (CLI)`}</li>
      <li parentName="ul">{`the registry`}</li>
    </ul>
    <p>{`Use the `}<a parentName="p" {...{
        "href": "https://npmjs.com"
      }}><em parentName="a">{`website`}</em></a>{` to discover packages, set up profiles, and manage other aspects of your npm experience. For example, you can set up `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/features"
      }}>{`organizations`}</a>{` to manage access to public or private packages.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/cli/npm"
      }}><em parentName="a">{`CLI`}</em></a>{` runs from a terminal, and is how most developers interact with npm.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/misc/registry"
      }}><em parentName="a">{`registry`}</em></a>{` is a large public database of JavaScript software and the meta-information surrounding it.`}</p>
    <h2>{`Use npm to . . .`}</h2>
    <ul>
      <li parentName="ul">{`Adapt packages of code for your apps, or incorporate packages as they are.`}</li>
      <li parentName="ul">{`Download standalone tools you can use right away.`}</li>
      <li parentName="ul">{`Run packages without downloading using `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/npx"
        }}>{`npx`}</a>{`.`}</li>
      <li parentName="ul">{`Share code with any npm user, anywhere.`}</li>
      <li parentName="ul">{`Restrict code to specific developers.`}</li>
      <li parentName="ul">{`Create organizations to coordinate package maintenance, coding, and developers.`}</li>
      <li parentName="ul">{`Form virtual teams by using organizations.`}</li>
      <li parentName="ul">{`Manage multiple versions of code and code dependencies.`}</li>
      <li parentName="ul">{`Update applications easily when underlying code is updated.`}</li>
      <li parentName="ul">{`Discover multiple ways to solve the same puzzle.`}</li>
      <li parentName="ul">{`Find other developers who are working on similar problems and projects.  `}</li>
    </ul>
    <h2>{`Getting started`}</h2>
    <p>{`To get started with npm, you can `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/signup"
      }}>{`create an account`}</a>{`, which will be available at `}<a parentName="p" {...{
        "href": "http://www.npmjs.com/~*yourusername"
      }}>{`http://www.npmjs.com/~*yourusername`}</a>{`*.`}</p>
    <p>{`After you set up an npm account, the next step is to use the command line interface (CLI) to `}<a parentName="p" {...{
        "href": "/downloading-and-installing-node-js-and-npm"
      }}>{`install npm`}</a>{`. We look forward to seeing what you create!`}</p>
    <h2>{`Sharing packages and collaborating with others`}</h2>
    <p>{`If you choose to share your packages publicly, there is no cost. To use and share private packages, you need to upgrade your account. To share with others, create organizations, called `}<strong parentName="p"><a parentName="strong" {...{
          "href": "/organizations"
        }}>{`npm organizations`}</a></strong>{`,  and invite others to work with you, privately (for a fee) or publicly (for free).`}</p>
    <p>{`You can also use a private npm package registry like `}<a parentName="p" {...{
        "href": "https://github.com/features/packages"
      }}>{`GitHub Packages`}</a>{` or the open source `}<a parentName="p" {...{
        "href": "https://verdaccio.org"
      }}>{`Verdaccio`}</a>{` project.  This lets you develop packages internally that are not shared publicly.`}</p>
    <h2>{`Learn more`}</h2>
    <p>{`To learn more about npm as a product, upcoming new features, and interesting uses of npm be sure to follow `}<a parentName="p" {...{
        "href": "https://twitter.com/npmjs"
      }}>{`@npmjs`}</a>{` on Twitter.`}</p>
    <p>{`For mentoring, tutorials, and learning, visit `}<a parentName="p" {...{
        "href": "https://nodeschool.io"
      }}>{`node school`}</a>{`. Consider attending or hosting a nodeschool event (usually free!) at a site near you, or use the self-help tools you can find on the site.`}</p>
    <h3>{`CLI reference documentation`}</h3>
    <p>{`While relevant CLI commands are covered throughout this user documentation, the CLI includes command line help, its own `}<a parentName="p" {...{
        "href": "/cli-documentation"
      }}>{`documentation section, and instant help (man pages)`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      